enum MediaFileType {
  IMAGE = 1,
  AUDIO = 2,
  VIDEO = 3,
  PDF = 4,
}

export default MediaFileType;

export const PLAYABLE_MEDIA = [
  MediaFileType.AUDIO,
  MediaFileType.VIDEO,
];

export function parseMediaFileType(mime: string): MediaFileType {
  if (mime.includes('image')) return MediaFileType.IMAGE;
  else if (mime.includes('audio')) return MediaFileType.AUDIO;
  else if (mime.includes('video')) return MediaFileType.VIDEO;
  else if (mime.includes('pdf')) return MediaFileType.PDF;
  else throw new Error(`Unknown media file type: ${mime}`);
}
